import { render, staticRenderFns } from "./ImportRecordDetail.vue?vue&type=template&id=1d9d640c&"
import script from "./ImportRecordDetail.vue?vue&type=script&lang=js&"
export * from "./ImportRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports